import React from 'react';
import { usePortal } from '../../contexts/PortalContext';
import { formatShootDate, isUpcoming, shootDay, shootMonth, shootYear } from '../../utils/time';
export function Schedule() {
  const {
    activeProject
  } = usePortal();
  const upcoming = [...activeProject.shoots].filter(shoot => isUpcoming(shoot.date)).sort((a, b) => a.date.localeCompare(b.date));
  const fallbackDate = isUpcoming(activeProject.nextShootDate) ? activeProject.nextShootDate : '';
  return <div data-id="element-625" data-mp="1nvm8dflfqok8">
      <h1 className="font-display text-5xl leading-[0.95] tracking-tight sm:text-7xl" data-id="element-626" data-mp="1nvduplhhnf7z">SCHEDULE</h1>
      <p className="label mt-8 text-mute" data-id="element-627" data-mp="1a4h9ifpw60ay">Upcoming</p>

      {upcoming.length === 0 ? <div className="mt-10 border-y border-rule py-12" data-id="element-628" data-mp="1f3286aphwbxa">
          {/* Only what Portal has actually saved — nothing is invented. */}
          <p className="font-display text-3xl leading-tight" data-id="element-629" data-mp="22rv4w9dxynsy">
            {fallbackDate ? formatShootDate(fallbackDate) : 'To be confirmed'}
          </p>
          {fallbackDate && activeProject.nextShootTime && <p className="mt-4 font-display text-2xl text-charcoal" data-id="element-630" data-mp="3urdd0l10r4b7">
              {activeProject.nextShootTime}
            </p>}
          {fallbackDate && activeProject.location && <p className="mt-3 font-display text-xl text-graphite" data-id="element-631" data-mp="8ctzsrns5v6b">{activeProject.location}</p>}
          {activeProject.callSheet ? <a href={activeProject.callSheet.url} target="_blank" rel="noreferrer" className="label mt-9 inline-block border border-ink px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-632" data-mp="i96spnbi4500">
              View Call Sheet
            </a> : <p className="mt-6 max-w-lg font-display text-lg text-graphite" data-id="element-633" data-mp="mbjww7alnuuo">
              Portal will confirm the full call sheet closer to the date.
            </p>}
        </div> : <ul className="m-0 mt-10 list-none border-t border-rule p-0" data-id="element-634" data-mp="2o3ygrbwpf9dq">
          {upcoming.map((shoot, index) => <li key={shoot.id} className="border-b border-rule py-12" data-id="element-635" data-mp="s1d8thew7pju" data-mpi={index}>
              <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-636" data-mp="wz50qbfjfbo1">
                <div className="lg:col-span-3" data-id="element-637" data-mp="11wdgy6h4l5mn">
                  <p className="font-display text-6xl leading-none tracking-tight sm:text-7xl" data-id="element-638" data-mp="11zsz5i63iusa">
                    {shootDay(shoot.date)}
                  </p>
                  <p className="label mt-4 text-mute" data-id="element-639" data-mp="1axbouzuopxai">
                    {shootMonth(shoot.date)} {shootYear(shoot.date)}
                  </p>
                </div>

                <div className="lg:col-span-6" data-id="element-640" data-mp="1knefitec2z5o">
                  <h2 className="font-display text-3xl leading-tight sm:text-4xl" data-id="element-641" data-mp="1kops9iprbh8x">
                    {shoot.title.toUpperCase()}
                  </h2>
                  <p className="mt-4 font-display text-xl text-charcoal" data-id="element-642" data-mp="1tp4eckajp0dh">
                    {[formatShootDate(shoot.date), shoot.time, shoot.city].filter(Boolean).join(' · ')}
                  </p>
                  {shoot.location && <p className="label mt-5 text-mute" data-id="element-643" data-mp="3j3djjttwbwcf">{shoot.location}</p>}
                  {index === 0 && activeProject.callSheet && <a href={activeProject.callSheet.url} target="_blank" rel="noreferrer" className="label mt-9 inline-block border border-ink px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-644" data-mp="3a4a02oqthexe">
                      View Call Sheet
                    </a>}
                </div>

                <dl className="m-0 lg:col-span-3" data-id="element-645" data-mp="3t2345ud6fuwd">
                  {shoot.details.map(detail => <div key={detail.label} className="flex items-baseline justify-between gap-4 border-b border-rule py-3 last:border-b-0" data-id="element-646" data-mp="3o2qgx8ie8lt9">
                      <dt className="label m-0 text-mute" data-id="element-647" data-mp="km9k55jn01ak">{detail.label}</dt>
                      <dd className="m-0 font-sans text-sm tracking-wide2 text-charcoal" data-id="element-648" data-mp="471vdqpjn6vv">
                        {detail.value}
                      </dd>
                    </div>)}
                </dl>
              </div>
            </li>)}
        </ul>}
    </div>;
}